module.exports = "/_next/static/images/StreamlineCompliance@2x-21f9c039fa1c4dcb1cbe83c9c53cde70.webp";